import { resizeContentHeight } from "../../../utils/resizeContentHeight";
import { MinimizeIframeNotice } from "../../../customNotice/botNotice/minimizeIframeNotice";
import { TrackingNotice } from "../../../customNotice/botNotice/trackingNotice";
export class IframeExtension {
    constructor(chatScreen) {
        this.name = 'iframe';
        /**
         * Change Resize Button Icons to minimized
         */
        this.minimizedView = () => {
            this.elements['iframeResizeButton'].removeClass('cbot-icon-resize-minimize');
            this.elements['iframeResizeButton'].addClass('cbot-icon-resize-maximize');
        };
        /**
         * Change Resize Button Icons to maximized
         */
        this.maximizedView = () => {
            this.elements['iframeResizeButton'].removeClass('cbot-icon-resize-maximize');
            this.elements['iframeResizeButton'].addClass('cbot-icon-resize-minimize');
        };
        /**
         * Minimizes/Maximizes Iframe
         */
        this.resizeButtonClick = () => {
            // toggle view
            if (this.mode == 'maximized') {
                this.minimizeIframe("resizeButton");
            }
            else {
                this.maximizeIframe();
            }
        };
        /**
         * Minimize Iframe
         *
         * @param origin - optional origin of event
         */
        this.minimizeIframe = (origin) => {
            this.mode = 'minimized';
            this.minimizedView();
            this.elements['iframe'].hide();
            this.chatScreen.elements['chatWindowMain'].show();
            this.chatScreen.resizeContent();
            if (this.metaData) {
                let minimizeIframeNotice = new MinimizeIframeNotice(this.metaData.target, this.metaData.url, this.metaData.title, origin);
                this.chatScreen.uic.widget.sendCustomNotice(minimizeIframeNotice);
            }
        };
        /**
         * Maximize Iframe
         */
        this.maximizeIframe = () => {
            this.mode = 'maximized';
            this.maximizedView();
            this.chatScreen.elements['chatWindowMain'].hide();
            this.elements['iframe'].show();
            this.resizeIframeHeight();
        };
        /**
        * Resizes the iframe to fit chat window height
        */
        this.resizeIframeHeight = () => {
            resizeContentHeight(this.chatScreen.elements['widgetWindow'], this.elements['iframe']);
            this.elements['iframe'].css('height', parseInt(this.elements['iframe'].css('height')) - parseInt(this.elements['iframe'].css('margin-top')) + "px");
            this.elements['iframe'].css('max-height', parseInt(this.elements['iframe'].css('max-height')) - parseInt(this.elements['iframe'].css('margin-top')) + "px");
        };
        this.chatScreen = chatScreen;
        this.active = false;
        this.elements = {};
        // iframe Mode
        this.elements['iframeContainer'] = $('#chatWindow_iframe');
        this.elements['iframeHeader'] = $('#cbot-iframeHeader');
        this.elements['iframeHeaderText'] = $('#cbot-iframeText');
        this.elements['iframeProgressbar'] = $('#chatWindow_iframe .progressbar');
        this.elements['iframe'] = $('#chatWindow_iframe iframe');
        this.elements['iframeResizeButton'] = $('#cbot-iframeResizeButton');
        let iframeURLChange = (iframe, callback) => {
            var unloadHandler = function () {
                // Timeout needed because the URL changes immediately after
                // the `unload` event is dispatched.
                setTimeout(function () {
                    callback();
                }, 0);
            };
            var attachUnload = () => {
                // Remove the unloadHandler in case it was already attached.
                // Otherwise, the change will be dispatched twice.
                iframe.contentWindow.removeEventListener("unload", unloadHandler);
                iframe.contentWindow.addEventListener("unload", unloadHandler);
            };
            iframe.addEventListener("load", attachUnload);
            attachUnload();
        };
        iframeURLChange(this.elements['iframe'].get(0), () => {
            this.elements['iframeProgressbar'].removeClass('animateFinished');
            this.elements['iframeProgressbar'].addClass('animateLoad');
        });
        this.elements['iframe'].on("load", () => {
            let width = this.elements['iframeProgressbar'].width();
            this.elements['iframeProgressbar'].removeClass('animateLoad');
            this.elements['iframeProgressbar'].css('width', width);
            setTimeout(() => {
                this.elements['iframeProgressbar'].addClass('animateFinished');
            }, 0);
            var requestTime = this.elements['iframe'].attr('data-time');
            var loadTime = new Date().getTime();
            var difference = loadTime - requestTime;
            if (difference < 1000) {
                this.chatScreen.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Iframe_view_error", "Iframe_view_error"));
            }
        });
        this.elements['iframeProgressbar'].on('transitionend webkitTransitionEnd oTransitionEnd', () => {
            setTimeout(() => {
                this.elements['iframeProgressbar'].css('width', "0%");
                this.elements['iframeProgressbar'].removeClass('animateFinished');
            }, 1000);
        });
        this.elements['iframeResizeButton'].click(() => {
            this.resizeButtonClick();
        });
        this.chatScreen.elements['chatInputTextArea'].focusin(() => {
            if (this.active && this.mode == 'maximized') {
                this.minimizeIframe("inputField");
                this.elements['iframeResizeButton'].addClass('animate');
            }
        });
        this.elements['iframeResizeButton'].on("animationend", () => {
            this.elements['iframeResizeButton'].removeClass('animate');
        });
        // -----------------------------------------------------------------------------
        //                         DYNAMICALLY RESIZE CONTENT
        // -----------------------------------------------------------------------------
        $('.cbot-chatbotWindow').onload = this.resizeIframeHeight();
    }
    /**
     * Activates the iframe extension
     *
     * @param options example: { url: "https://www.a1.net", title: "A1.NET"}
     */
    activate(options) {
        this.active = true;
        this.mode = 'maximized';
        this.maximizedView();
        this.chatScreen.elements['chatWindowMainHeader'].hide();
        this.chatScreen.elements['chatWindowMain'].hide();
        this.elements['iframe'].show();
        this.elements['iframeContainer'].show();
        if (options) {
            this.metaData = options;
            var time = new Date().getTime();
            this.elements['iframe'].attr('data-time', time);
            if (options.url)
                this.elements['iframe'].attr('src', options.url);
            if (options.title)
                this.elements['iframeHeaderText'].text(options.title);
        }
        this.resizeIframeHeight();
    }
    /**
     * Deactivate the iframe extension
     */
    deactivate() {
        this.active = false;
        this.chatScreen.elements['chatWindowMainHeader'].show();
        this.chatScreen.elements['chatWindowMain'].show();
        this.elements['iframeContainer'].hide();
    }
    resize() {
        this.resizeIframeHeight();
    }
}
